<template>
    <v-flex>
        <h1 class="display-2">Agregar Items</h1>
        <br>
        <v-container fluid>
            <v-layout>
                <v-flex>
                    <v-stepper v-model="paso" non-linear dark>
                        <v-stepper-header>
                            <v-stepper-step step="1" :complete="paso > 1">¿Existe en microsiga?</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step step="2" :complete="paso > 2">Producto Existente</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step step="3">Producto Nuevo</v-stepper-step>
                        </v-stepper-header>
                        <v-stepper-items>
                            <v-stepper-content step="1">
                                <v-btn color="primary" @click.native="paso = 2">SI</v-btn>
                                <v-btn flat @click.native="paso = 3">NO</v-btn>
                            </v-stepper-content>
                            <v-stepper-content step="2">
                                <form data-vv-scope="form-micro" @submit.prevent="guardar('form-micro')" ref="formMicro">
                                    <v-container grid-list-md>
                                        <v-layout>
                                            <v-flex>
                                                <empresa-select v-model="empresa_id"></empresa-select>
                                            </v-flex>
                                            <v-flex>
                                                <v-select
                                                        label="Búsqueda de Item"
                                                        autocomplete
                                                        :loading="loadingItem"
                                                        :items="items"
                                                        :search-input.sync="search"
                                                        v-model="micro"
                                                        item-text="TXT"
                                                        item-value="B1_COD"
                                                        return-object
                                                        clearable
                                                        chips
                                                ></v-select>
                                            </v-flex>
                                            <v-flex>
                                                <v-btn @click.native="agregar" color="green" dark>AGREGAR</v-btn>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout>
                                            <v-flex>
                                                <v-text-field readonly label="ID Friolatina" v-model="d.micro_id_1"></v-text-field>
                                            </v-flex>
                                            <v-flex>
                                                <v-text-field readonly label="Desc Friolatina" v-model="d.micro_desc_1"></v-text-field>
                                            </v-flex>
                                            <v-flex>
                                                <v-text-field readonly label="UM Friolatina" v-model="d.micro_um_1"></v-text-field>
                                            </v-flex>
                                            <v-flex class="text-xs-center">
                                                <v-btn @click.native="copiar(1)" fab dark small color="primary">
                                                    <v-icon>content_copy</v-icon>
                                                </v-btn>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout>
                                            <v-flex>
                                                <v-text-field readonly label="ID Bervill" v-model="d.micro_id_2"></v-text-field>
                                            </v-flex>
                                            <v-flex>
                                                <v-text-field readonly label="Desc Bervill" v-model="d.micro_desc_2"></v-text-field>
                                            </v-flex>
                                            <v-flex>
                                                <v-text-field readonly label="UM Bervill" v-model="d.micro_um_2"></v-text-field>
                                            </v-flex>
                                            <v-flex class="text-xs-center">
                                                <v-btn @click.native="copiar(2)" fab dark small color="primary">
                                                    <v-icon>content_copy</v-icon>
                                                </v-btn>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout>
                                            <v-flex>
                                                <v-text-field readonly label="ID Acerolatina" v-model="d.micro_id_3"></v-text-field>
                                            </v-flex>
                                            <v-flex>
                                                <v-text-field readonly label="Desc Acerolatina" v-model="d.micro_desc_3"></v-text-field>
                                            </v-flex>
                                            <v-flex>
                                                <v-text-field readonly label="UM Acerolatina" v-model="d.micro_um_3"></v-text-field>
                                            </v-flex>
                                            <v-flex class="text-xs-center">
                                                <v-btn @click.native="copiar(3)" fab dark small color="primary">
                                                    <v-icon>content_copy</v-icon>
                                                </v-btn>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout>
                                            <v-flex>
                                                <v-text-field label="Código" v-model="d.codigo"
                                                              :error-messages="errores.collect('codigo')"
                                                              v-validate="'required'"
                                                              data-vv-name="codigo"
                                                              data-vv-scope="form-micro"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex>
                                                <v-text-field label="Descripción" v-model="d.desc" v-validate="'required'"
                                                              :error-messages="errores.collect('desc')"
                                                              data-vv-name="desc"
                                                              data-vv-scope="form-nuevo"></v-text-field>
                                            </v-flex>
                                            <v-flex>
                                                <v-select label="Tipo de Item" v-model="d.item_tipo_id"
                                                          single-line
                                                          :items="tipos"
                                                          :error-messages="errores.collect('item_tipo_id')"
                                                          v-validate="'required'"
                                                          item-value="id"
                                                          item-text="desig"
                                                          data-vv-name="item_tipo_id"
                                                          data-vv-scope="form-micro"
                                                ></v-select>
                                            </v-flex>
                                            <v-flex v-if="d.item_tipo_id == 'pan'">
                                                <v-text-field label="Ancho" v-model="d.ancho"></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                    <v-btn color="primary" type="submit" :loading="loading">GUARDAR</v-btn>
                                    <v-btn flat @click.native="paso = 1">Cancelar</v-btn>
                                </form>
                            </v-stepper-content>
                            <v-stepper-content step="3">
                                <form data-vv-scope="form-nuevo" @submit.prevent="guardar('form-nuevo')" ref="formNuevo">
                                    <v-container grid-list-md>
                                        <v-layout>
                                            <v-flex>
                                                <v-text-field label="Código" v-model="d.codigo" :loading="loadingValId"
                                                              :error-messages="errores.collect('codigo')"
                                                              v-validate="'valida_id'"
                                                              data-vv-name="codigo"
                                                              persistent-hint
                                                              hint="Este código va a ser utilizado para vincular a microsiga"
                                                              data-vv-scope="form-nuevo"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex>
                                                <v-text-field label="Descripción" v-model="d.desc" data-vv-scope="form-nuevo"></v-text-field>
                                            </v-flex>
                                            <v-flex>
                                                <v-text-field label="Unidad de medida" v-model="d.um"
                                                              :error-messages="errores.collect('um')"
                                                              v-validate="'required|max:2'"
                                                              data-vv-name="um"
                                                              data-vv-scope="form-nuevo"
                                                ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout>
                                            <v-flex>
                                                <v-select label="Tipo de Item" v-model="d.item_tipo_id"
                                                          single-line
                                                          :items="tipos"
                                                          :error-messages="errores.collect('item_tipo_id')"
                                                          v-validate="'required'"
                                                          item-value="id"
                                                          item-text="desig"
                                                          data-vv-name="item_tipo_id"
                                                          data-vv-scope="form-nuevo"
                                                ></v-select>
                                            </v-flex>
                                            <v-flex v-if="d.item_tipo_id == 'pan'">
                                                <v-text-field label="Ancho" v-model="d.ancho"></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                    <v-btn color="primary" type="submit" :loading="loading">Guardar</v-btn>
                                    <v-btn flat @click.native="paso = 1">Cancel</v-btn>
                                </form>
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>
                </v-flex>
            </v-layout>
        </v-container>
        <errores v-model="msj.mostrar" :datos="msj"></errores>
    </v-flex>
</template>

<script>
    import empresaSelect from '../../../components/EmpresaSelect.vue';
    import errores from '../../../components/Errores';
    import {Validator} from 'vee-validate';
    import listas from '../../../mixins/items';

    export default {
        name: "add",
        $_veeValidate: {
            validator: 'new'
        },
        components: {errores, empresaSelect},
        mixins: [listas],
        data() {
            return {
                loading: false,
                micro: '',
                empresa_id: '',
                search: '',
                loadingItem: false,
                loadingValId: false,
                paso: 0,
                tipos: [],
                d: {
                    codigo: '',
                    desc: '',
                    um: '',
                    item_tipo_id: '',
                    ancho: '',
                    micro_id_1: '',
                    micro_id_2: '',
                    micro_id_3: '',
                    micro_desc_1: '',
                    micro_desc_2: '',
                    micro_desc_3: '',
                    micro_um_1: '',
                    micro_um_2: '',
                    micro_um_3: '',
                },
                msj: {
                    mostrar: false,
                    txt: '',
                    tipo: ''
                },
                items: []
            }
        },
        watch: {
            search(val) {
                val && this.buscarId(val)
            },
            empresa_id() {
                this.search = '';
                this.items = [];
            }
        },
        mounted() {
            Validator.extend('valida_id', {
                getMessage: () => `El id del item ya existe en microsiga`,
                validate: value => new Promise((resolve) => {
                    this.loadingValId = true;
                    this.$http.post('items/micro-existe', {id: value})
                        .then(r => {
                            resolve({valid: (r.data !== true)});
                            this.loadingValId = false;
                        })
                        .catch(e => {
                            resolve({valid: false});
                            this.loadingValId = false;
                        })
                })
            });
            this.itemTipos(r => {
                this.tipos = r;
            });
        },
        methods: {
            copiar(emp) {
                this.d.codigo = this.d['micro_id_' + emp];
                this.d.desc = this.d['micro_desc_' + emp];
                this.d.um = this.d['micro_um_' + emp];
            },
            agregar() {
                this.d['micro_id_' + this.empresa_id] = this.micro.B1_COD;
                this.d['micro_desc_' + this.empresa_id] = this.micro.B1_DESC;
                this.d['micro_um_' + this.empresa_id] = this.micro.B1_UM;
                this.d.ancho = this.micro.B1_ANCHO;
            },
            buscarId(val) {
                if (this.empresa_id.length === 0) {
                    return false;
                }
                this.loadingItem = true;
                this.$http.post('items/micro-search', {q: val, empresa_id: this.empresa_id})
                    .then(r => {
                        this.items = r.data;
                        this.loadingItem = false;
                    })
            },
            guardar(formulario) {
                this.$validator.validateAll(formulario)
                    .then(r => {
                        if (!r) {
                            return false;
                        }
                        this.loading = true;
                        this.$http.post('items', this.d)
                            .then(r => {
                                this.msj = r.data;
                                this.$validator.reset();
                                for (let key in this.d) {
                                    this.d[key] = '';
                                }
                                this.loading = false;
                                this.paso = 1;
                            })
                            .catch(e => {
                                if (e.response.status === 422) {
                                    this.msj = {
                                        tipo: 'error',
                                        txt: 'Error de valiación',
                                        errores: e.response.data.errors,
                                        mostrar: true
                                    };
                                } else {
                                    this.msj = {
                                        tipo: 'error',
                                        txt: 'Error de guardado',
                                        errores: e.response,
                                        mostrar: true
                                    };
                                }
                                this.loading = false;
                            })
                    })
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/presup/item/add.vue